/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'utm': {
    width: 16,
    height: 16,
    viewBox: '0 0 116 54',
    data: '<g transform="translate(-6 -6)" _fill="none" fill-rule="evenodd"><rect pid="0" _stroke="#000" stroke-width="3" x="7.5" y="7.5" width="113" height="51" rx="7"/><text font-family="Helvetica" font-size="38" letter-spacing=".461" _fill="#000"><tspan x="22" y="47">UTM</tspan></text></g>'
  }
})
